export const displayCount = (value) => {
  if (typeof value !== 'number') return 0
  return value > 10000 ? (value / 10000).toFixed(2) + 'w' : value
}

export const indicatorFav = (value) => {
  return Math.floor(value * (1 + Math.log10(Math.sqrt(value) + 1) / 20) / 455)
}

export const toFixed = (value, precision) => {
  return (+value || 0).toFixed(precision).replace(/^-(0(\.0+)?)$/, '$1')
}

/**
  * 转换成热度指数(例如: 播放指数 = (播放量 * (1 + lg(sqrt(播放量) + 1) / 20)) / 455)
  * @param {Number} num 原始值
  * @returns {String} 热度指数
  * */
export const formatHotIndex = (num, fixed = 2) => {
  if (num === 0) {
    return '0'
  }
  // 有可能存在0.00的情况, 代表播放很少, 但并不为0
  return ((num * (1 + Math.log10(Math.sqrt(num) + 1) / 20)) / 455).toFixed(fixed)
}

const filters = {
  displayCount,
  indicatorFav,
  toFixed,
  formatHotIndex
}

export default function install(Vue) {
  Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
  })
}
